import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Input from '../reuseable/Input';
import { get_toolbox_mode_list } from '../../App/validation/toolbox_mode_list';
import {
  // generate_isochrone,
  generate_isochrone_mapbox,
  set_value_toolbox
} from '../../App/actions/toolboxActions';
import ProgressBarButton from '../reuseable/ProgressBarButton';
import { get_transportation_profiles } from '../../App/validation/transportation_profiles';
import useLanguage from '../common_hooks/useLanguage';

const profiles = get_transportation_profiles();

function SETTING_ISOCHRONE() {
  const { map_object } = useSelector((state) => (state.layer));
  const toolbox = useSelector((state) => (state.toolbox)) || {};
  const { name_toolbox, uuid_name, mode_toolbox, isochrone_profile, features_isochrone_polygon } = toolbox;
  const [distance, set_distance] = useState("-");

  const selected_row_toolbox_ids = toolbox[uuid_name];
  const features = toolbox[mode_toolbox];
  const tool = get_toolbox_mode_list(mode_toolbox);
  const unit_options = tool?.unit_options || [];
  const [unit, set_unit] = useState(unit_options?.[0] || "");
  const [loading_progress, set_loading_progress] = useState(0);
  const [is_loading, set_is_loading] = useState(false);
  const [is_mode_expand, set_is_mode_expand] = useState(false);


  const dispatch = useDispatch();
  const { dict, language } = useLanguage();


  const handle_generate_isochrone = async () => {
    set_is_loading(true)
    set_loading_progress(0)

    // ✅ Yield ke browser dulu supaya loading bar langsung kerender
    await new Promise(resolve => setTimeout(resolve, 0));

    const features_polygon = { ...features_isochrone_polygon }

    for (const [index, f] of features.entries()) {
      set_loading_progress(parseInt(((index + 1) / features.length) * 90))
      let new_feature = { ...f }
      if (selected_row_toolbox_ids.includes(f.properties.uuid)) {
        new_feature = {
          ...new_feature,
          properties: {
            ...new_feature.properties,
            isochrone_profile
          }
        }

        if (unit === "meter") new_feature["properties"]["distance_limit"] = distance;
        else new_feature["properties"]["time_limit"] = distance;
        const result_isochrone_feature = await dispatch(generate_isochrone_mapbox(new_feature));
        if (result_isochrone_feature) features_polygon[new_feature.properties.uuid] = result_isochrone_feature
      };
    }

    const geojson = {
      type: "FeatureCollection",
      features: Object.keys(features_polygon).map(key => features_polygon[key]),
    };

    const isochrone_polygon_id = "geojson_isochrone_polygon";
    if (map_object?.getSource(isochrone_polygon_id))
      map_object?.getSource(isochrone_polygon_id).setData(geojson);

    dispatch(set_value_toolbox({
      key: "features_isochrone_polygon",
      value: features_polygon
    }))

    set_loading_progress(100)
    set_is_loading(false)

  }

  const change_unit = (value) => {
    if (unit_options.includes(value)) set_unit(value)
  }

  const on_change_distance = (e) => {
    const value = parseFloat(e.target.value);
    set_distance(value);
  }

  const change_profile = (value) => {
    if (!profiles?.[value]) return;
    dispatch(set_value_toolbox({
      key: "isochrone_profile",
      value: value
    }))
  }

  return (
    <div
      style={{
        width: "230px",
        // width: "360px",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        margin: "10px 0 10px 0",
      }}
    >
      {name_toolbox &&
        <section
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <div
            style={{
              fontWeight: 700,
              fontSize: "16px",
              lineHeight: "19px",
              color: "#000000",
            }}
          >
            {language === "ina" && `${dict["Setting"][language]} `}
            {`${name_toolbox}`}
            {language === "eng" && ` ${dict["Setting"][language]}`}
          </div>

          {/* {selected_row_toolbox_ids?.length > 0 &&  */}
          <div
            style={{
              fontSize: "12px",
              color: "#000000",
            }}
          >
            {`${selected_row_toolbox_ids?.length} ${dict["Selected"][language]}`}
          </div>
          {/* } */}
        </section>
      }

      <hr />

      <section
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#F5F5F5",
          padding: "6px 8px",
          marginBottom: "15px",
          borderRadius: "15px",
        }}
      >
        <div
          className='center_perfect'
          style={{
            width: "160px",
            height: "29px",
            borderRadius: "5px",
            backgroundColor: unit === "meter" ? "#fff" : "#ffffff00",
            fontWeight: unit === "meter" ? "700" : "400",
            cursor: "pointer",
            fontSize: "14px"
          }}
          onClick={() => change_unit("meter")}
        >
          {dict["Meters"][language]}
        </div>
        <div
          className='center_perfect'
          style={{
            width: "160px",
            height: "29px",
            borderRadius: "5px",
            backgroundColor: unit === "minute" ? "#fff" : "#ffffff00",
            fontWeight: unit === "minute" ? "700" : "400",
            cursor: "pointer",
            fontSize: "14px"
          }}
          onClick={() => change_unit("minute")}
        >
          {dict["Minutes"][language]}
        </div>
      </section>

      {/* <hr style={{ height: "5px", backgroundColor: "#BABABA", opacity: 0.1 }} /> */}

      <section style={{ display: "flex", flexDirection: "column", gap: "15px", marginBottom: "20px" }}>
        <div onClick={() => set_is_mode_expand(!is_mode_expand)} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer" }}>
          <span style={{ fontSize: "14px" }}>{dict["Transportation Mode"][language]}</span>
          <svg
            style={{
              transition: "transform 0.5s ease 0s",
              transform: `${is_mode_expand ? "rotate(180deg)" : "rotate(0deg)"}`,
            }}
            xmlns="http://w3.org"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>

        {is_mode_expand &&
          <div style={{ display: "flex", gap: "5px", justifyContent: "space-around" }}>
            {
              Object.keys(profiles).map(key => (
                <div
                  key={key}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    cursor: "pointer",
                    gap: "5px"
                  }}
                >
                  <button
                    onClick={() => change_profile(key)}
                    disabled={!profiles[key]?.mapbox}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "100%",
                      width: "50px",
                      height: "50px",
                      border: `1px solid`,
                      backgroundColor: isochrone_profile === key ? "black" : !profiles[key]?.mapbox ? "#ABABAB80" : "white"
                    }}
                  >
                    <img
                      alt={profiles[key].name}
                      src={profiles[key].icon}
                      style={{
                        width: "30px",
                        height: "30px",
                        filter: isochrone_profile === key || !profiles[key]?.mapbox ? "invert(0%)" : "invert(100%)",
                        // backgroundColor: isochrone_profile === key ? "black" : "white"
                      }}
                    />
                  </button>
                  <label style={{ cursor: "pointer", color: !profiles[key]?.mapbox ? "#ABABAB80" : "black" }}>{dict[profiles[key].name][language]}</label>
                </div>
              ))
            }

          </div>
        }
      </section>

      <section>
        <span style={{ fontSize: "14px" }}>{`${dict[unit === "meter" ? "Distance" : "Time"][language]} (${dict[unit][language]})`}</span>
        <Input
          style={{ margin: "15px 0 15px 0" }}
          value={distance}
          type="number"
          onChange={(e) => on_change_distance(e)}
          max={unit === "minute" ? 60 : 1000}
        />
      </section>

      <section>
        <ProgressBarButton
          progress={loading_progress}
          is_loading={is_loading}
          onClick={() => {
            if (!isNaN(distance)) handle_generate_isochrone()
          }}
        >
          {dict["Generate"][language]}
        </ProgressBarButton>
        {/* <button
          style={{
            backgroundColor: !isNaN(distance) ? "black" : "#ABABAB",
            color: "white",
            width: "100%",
            borderRadius: "15px",
            height: "40px",
            fontSize: "14px"
          }}
          onClick={() => { if (!isNaN(distance)) handle_generate_isochrone() }}
        >
          Generate
        </button> */}
      </section>
    </div >

  )
}

export default SETTING_ISOCHRONE